var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDashboard = function SvgDashboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 738 430"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dashboard_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 738,
    height: 430,
    fill: "#00674F",
    fillOpacity: 0.1,
    rx: 32
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dashboard_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 722,
    height: 414,
    x: 8,
    y: 8,
    fill: "#fff",
    rx: 32
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dashboard_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E6EDEA",
    d: "M307.703 127.82H364.8v15.86h-57.097zM224.172 118.305h57.097v9.516h-57.097zM391.234 143.682h57.097v23.262h-57.097zM474.766 166.943h57.097v17.975h-57.097zM558.297 184.918h57.097v7.402h-57.097z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E6EDEA",
    strokeWidth: 1.057,
    d: "M120.547 80.768h523.394M120.547 124.12h523.394M120.547 167.472h523.394M120.547 210.824h523.394M120.547 254.175h523.394"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00584C",
    d: "M140.637 118.305h57.097v136.4h-57.097z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00674F",
    d: "M224.172 127.82h57.097v126.883h-57.097zM307.703 143.682H364.8v111.023h-57.097z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#28A37B",
    d: "M391.234 166.943h57.097v87.761h-57.097zM474.766 184.918h57.097v69.786h-57.097zM558.297 192.318h57.097v62.384h-57.097z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.803,
    height: 6.344,
    x: 101.516,
    y: 251.531,
    fill: "#E9EFEC",
    rx: 3.172
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.803,
    height: 6.344,
    x: 101.516,
    y: 208.18,
    fill: "#E9EFEC",
    rx: 3.172
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.803,
    height: 6.344,
    x: 101.516,
    y: 164.828,
    fill: "#E9EFEC",
    rx: 3.172
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.803,
    height: 6.344,
    x: 101.516,
    y: 121.477,
    fill: "#E9EFEC",
    rx: 3.172
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.803,
    height: 6.344,
    x: 101.516,
    y: 78.125,
    fill: "#E9EFEC",
    rx: 3.172
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E7CF60",
    strokeWidth: 3.172,
    d: "M169.186 118.832C383.5 136 410.5 186.5 589.205 193.069"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169.186,
    cy: 118.304,
    r: 4.229,
    fill: "#F5F7F6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169.189,
    cy: 118.304,
    r: 2.114,
    fill: "#0A3C30"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 253.776,
    cy: 127.821,
    r: 4.229,
    fill: "#F5F7F6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 253.775,
    cy: 127.82,
    r: 2.115,
    fill: "#0A3C30"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.249,
    cy: 143.681,
    r: 4.229,
    fill: "#F5F7F6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.252,
    cy: 143.682,
    r: 2.115,
    fill: "#0A3C30"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.78,
    cy: 166.942,
    r: 4.229,
    fill: "#F5F7F6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.783,
    cy: 166.943,
    r: 2.115,
    fill: "#0A3C30"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 503.315,
    cy: 184.917,
    r: 4.229,
    fill: "#F5F7F6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 503.314,
    cy: 184.918,
    r: 2.115,
    fill: "#0A3C30"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586.847,
    cy: 192.319,
    r: 4.229,
    fill: "#F5F7F6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586.846,
    cy: 192.32,
    r: 2.115,
    fill: "#0A3C30"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#37413F",
    d: "m97.8 49.58-5.44-8.64h3.14l4.22 6.92h-1.8l4.22-6.92h3.1l-5.5 8.64zM97.44 55v-6.88h2.74V55zm10.944.2q-1.461 0-2.64-.66a5.3 5.3 0 0 1-1.86-1.82q-.68-1.16-.68-2.58t.68-2.54a4.9 4.9 0 0 1 1.86-1.8q1.18-.68 2.62-.68 1.479 0 2.64.68a4.93 4.93 0 0 1 1.86 1.8q.68 1.12.68 2.54t-.68 2.58a5.1 5.1 0 0 1-1.86 1.82q-1.16.66-2.62.66m-.02-2.44q.74 0 1.3-.32a2.25 2.25 0 0 0 .88-.92q.32-.6.32-1.36t-.32-1.34a2.3 2.3 0 0 0-.88-.9q-.56-.34-1.3-.34-.72 0-1.28.34a2.3 2.3 0 0 0-.88.9q-.32.58-.32 1.34t.32 1.36q.32.58.88.92.56.32 1.28.32m10.986 2.44q-1.28 0-2.28-.54a3.97 3.97 0 0 1-1.54-1.5q-.56-.96-.56-2.22v-5.6h2.64v5.54q0 .6.2 1.04.201.42.6.64.4.22.94.22.82 0 1.28-.5t.46-1.4v-5.54h2.62v5.6q0 1.28-.56 2.24-.54.96-1.54 1.5-.98.52-2.26.52m6.447-.2v-9.66h2.62V55zm2.62-5.34-1.02-.68q.18-1.78 1.04-2.8.86-1.04 2.48-1.04.699 0 1.26.24.56.22 1.02.74l-1.64 1.88a1.4 1.4 0 0 0-.54-.36 1.9 1.9 0 0 0-.7-.12q-.84 0-1.38.54-.52.52-.52 1.6m9.958 5.34v-9.66h2.62V55zm6.3 0v-5.7q0-.84-.54-1.3-.52-.48-1.3-.48-.52 0-.94.22-.42.2-.66.6t-.24.96l-1.02-.5q0-1.12.48-1.94a3.4 3.4 0 0 1 1.34-1.26q.84-.46 1.9-.46 1 0 1.82.46.82.44 1.3 1.26.48.8.48 1.94V55zm6.3 0v-5.7q0-.84-.54-1.3-.52-.48-1.3-.48-.5 0-.94.22-.42.2-.66.6t-.24.96l-1.5-.36q.08-1.16.62-2a3.65 3.65 0 0 1 1.42-1.32q.88-.48 1.96-.48t1.94.46q.86.44 1.36 1.28t.5 2V55zm9.284.2q-1.461 0-2.64-.66a5.3 5.3 0 0 1-1.86-1.82q-.68-1.16-.68-2.58t.68-2.54a4.9 4.9 0 0 1 1.86-1.8q1.18-.68 2.62-.68 1.479 0 2.64.68a4.93 4.93 0 0 1 1.86 1.8q.68 1.12.68 2.54t-.68 2.58a5.1 5.1 0 0 1-1.86 1.82q-1.16.66-2.62.66m-.02-2.44q.74 0 1.3-.32a2.25 2.25 0 0 0 .88-.92q.32-.6.32-1.36t-.32-1.34a2.3 2.3 0 0 0-.88-.9q-.56-.34-1.3-.34-.72 0-1.28.34a2.3 2.3 0 0 0-.88.9q-.32.58-.32 1.34t.32 1.36q.32.58.88.92.56.32 1.28.32M173.605 55v-5.54q0-.86-.54-1.4t-1.4-.54q-.56 0-1 .24t-.7.68q-.24.44-.24 1.02l-1.02-.52q0-1.14.48-1.98a3.56 3.56 0 0 1 1.36-1.34q.88-.48 1.98-.48 1.06 0 1.9.54.84.52 1.32 1.38.48.84.48 1.82V55zm-6.5 0v-9.66h2.62V55zm12.534 0V41.32h2.62V55zm-2.26-7.36v-2.3h7.14v2.3zM192.492 55v-5.54q0-.86-.54-1.4t-1.4-.54q-.56 0-1 .24t-.7.68q-.24.44-.24 1.02l-1.02-.52q0-1.14.48-1.98.48-.86 1.32-1.34.86-.48 1.96-.48t1.94.48q.86.48 1.34 1.32t.48 1.94V55zm-6.5 0V40.54h2.62V55zm11.231 0V40.54h2.62V55zm7.981.08-4.04-9.74h2.84l2.68 7.44h-.96l2.78-7.44h2.86l-4.3 9.74zm-2.68 3.96 2.94-6.22 1.6 2.26-1.76 3.96zm18.694-3.84q-1.521 0-2.7-.64a5.07 5.07 0 0 1-1.88-1.8q-.68-1.14-.68-2.6 0-1.44.66-2.56a4.96 4.96 0 0 1 1.84-1.8q1.16-.68 2.58-.68 1.4 0 2.46.64 1.08.62 1.68 1.72.62 1.08.62 2.46 0 .26-.04.54a4 4 0 0 1-.1.6l-8.12.02v-1.96l6.9-.02-1.06.82q-.04-.86-.32-1.44a1.87 1.87 0 0 0-.78-.88q-.5-.32-1.24-.32-.78 0-1.36.36a2.3 2.3 0 0 0-.9.98q-.3.62-.3 1.48 0 .88.32 1.54.339.64.96 1 .62.34 1.44.34.74 0 1.34-.24a2.9 2.9 0 0 0 1.04-.76l1.54 1.54a4.46 4.46 0 0 1-1.72 1.24q-1 .42-2.18.42m6.2-.2v-9.66h2.62V55zm6.3 0v-5.7q0-.84-.54-1.3-.52-.48-1.3-.48-.52 0-.94.22-.42.2-.66.6t-.24.96l-1.02-.5q0-1.12.48-1.94a3.4 3.4 0 0 1 1.34-1.26q.84-.46 1.9-.46 1 0 1.82.46.82.44 1.3 1.26.48.8.48 1.94V55zm6.3 0v-5.7q0-.84-.54-1.3-.52-.48-1.3-.48a2.1 2.1 0 0 0-.94.22q-.42.2-.66.6t-.24.96l-1.5-.36q.08-1.16.62-2a3.65 3.65 0 0 1 1.42-1.32q.88-.48 1.96-.48t1.94.46q.86.44 1.36 1.28t.5 2V55zm4.744 0v-9.66h2.64V55zm1.32-11.22q-.64 0-1.06-.42a1.5 1.5 0 0 1-.42-1.08q0-.62.42-1.06t1.06-.44q.66 0 1.06.44.42.44.42 1.06 0 .64-.42 1.08-.4.42-1.06.42m6.961 11.44a6 6 0 0 1-1.62-.22q-.78-.22-1.44-.6a4.7 4.7 0 0 1-1.14-.96l1.56-1.58q.5.56 1.16.84t1.46.28q.639 0 .96-.18.34-.18.34-.54 0-.4-.36-.62-.34-.22-.9-.36l-1.18-.34q-.6-.2-1.16-.5-.56-.32-.92-.86-.34-.56-.34-1.44 0-.92.44-1.6.46-.68 1.299-1.06.841-.38 1.981-.38 1.2 0 2.16.42.98.42 1.62 1.26l-1.58 1.58a2.63 2.63 0 0 0-1-.78q-.54-.24-1.18-.24-.58 0-.9.18-.3.18-.3.5 0 .36.34.56a4.4 4.4 0 0 0 .92.36q.56.14 1.16.34.62.18 1.16.52.56.34.9.9.36.56.36 1.44 0 1.42-1.02 2.26-1.02.82-2.78.82m8.886 0a6 6 0 0 1-1.62-.22q-.78-.22-1.44-.6a4.7 4.7 0 0 1-1.14-.96l1.56-1.58q.5.56 1.16.84t1.46.28q.64 0 .96-.18.34-.18.34-.54 0-.4-.36-.62-.339-.22-.9-.36l-1.18-.34q-.6-.2-1.16-.5-.56-.32-.92-.86-.34-.56-.34-1.44 0-.92.44-1.6.46-.68 1.3-1.06t1.98-.38q1.2 0 2.16.42.981.42 1.62 1.26l-1.58 1.58a2.6 2.6 0 0 0-1-.78q-.54-.24-1.18-.24-.579 0-.9.18-.3.18-.3.5 0 .36.34.56.36.2.92.36.56.14 1.16.34.62.18 1.16.52.561.34.9.9.36.56.36 1.44 0 1.42-1.02 2.26-1.02.82-2.78.82m5.567-.22v-9.66h2.64V55zm1.32-11.22q-.64 0-1.06-.42a1.5 1.5 0 0 1-.42-1.08q0-.62.42-1.06t1.06-.44q.66 0 1.06.44.42.44.42 1.06 0 .64-.42 1.08-.4.42-1.06.42m8.181 11.42q-1.46 0-2.64-.66a5.3 5.3 0 0 1-1.86-1.82q-.68-1.16-.68-2.58t.68-2.54a4.9 4.9 0 0 1 1.86-1.8q1.18-.68 2.62-.68 1.48 0 2.64.68a4.9 4.9 0 0 1 1.86 1.8q.68 1.12.68 2.54t-.68 2.58a5.07 5.07 0 0 1-1.86 1.82q-1.16.66-2.62.66m-.02-2.44q.74 0 1.3-.32.58-.34.88-.92.32-.6.32-1.36t-.32-1.34a2.3 2.3 0 0 0-.88-.9q-.56-.34-1.3-.34-.72 0-1.28.34a2.3 2.3 0 0 0-.88.9q-.32.58-.32 1.34t.32 1.36q.32.58.88.92.56.32 1.28.32M290.344 55v-5.54q0-.86-.54-1.4t-1.4-.54q-.56 0-1 .24t-.7.68q-.24.44-.24 1.02l-1.02-.52q0-1.14.48-1.98a3.54 3.54 0 0 1 1.36-1.34q.879-.48 1.98-.48 1.06 0 1.9.54.84.52 1.32 1.38.48.84.48 1.82V55zm-6.5 0v-9.66h2.62V55zM101.94 311l-6.1-7.34 5.94-6.72h3.4l-6.62 7.3v-1.26l6.84 8.02zm-8.5 0v-14.06h2.72V311zm17.211.2q-1.52 0-2.7-.64a5.1 5.1 0 0 1-1.88-1.8q-.68-1.14-.68-2.6 0-1.44.66-2.56a4.97 4.97 0 0 1 1.84-1.8q1.16-.68 2.58-.68 1.4 0 2.46.64 1.08.62 1.68 1.72.62 1.08.62 2.46 0 .26-.04.54a4 4 0 0 1-.1.6l-8.12.02v-1.96l6.9-.02-1.06.82q-.04-.86-.32-1.44a1.86 1.86 0 0 0-.78-.88q-.5-.32-1.24-.32-.78 0-1.36.36a2.3 2.3 0 0 0-.9.98q-.3.62-.3 1.48 0 .88.32 1.54.34.64.96 1 .62.34 1.44.34.74 0 1.34-.24.6-.26 1.04-.76l1.54 1.54q-.7.82-1.72 1.24-1 .42-2.18.42m9.084-.12-4.04-9.74h2.84l2.68 7.44h-.96l2.78-7.44h2.86l-4.3 9.74zm-2.68 3.96 2.94-6.22 1.6 2.26-1.76 3.96zm14.074-4.04v-9.66h2.62V311zm6.3 0v-5.7q0-.84-.54-1.3-.52-.48-1.3-.48-.52 0-.94.22-.42.2-.66.6t-.24.96l-1.02-.5q0-1.12.48-1.94.5-.82 1.34-1.26.84-.46 1.9-.46 1 0 1.82.46.82.44 1.3 1.26.48.8.48 1.94v6.2zm6.3 0v-5.7q0-.84-.54-1.3-.52-.48-1.3-.48-.5 0-.94.22-.42.2-.66.6t-.24.96l-1.5-.36q.08-1.16.62-2a3.65 3.65 0 0 1 1.42-1.32q.88-.48 1.96-.48t1.94.46q.86.44 1.36 1.28t.5 2V311zm9.364.2q-1.521 0-2.7-.64a5.07 5.07 0 0 1-1.88-1.8q-.68-1.14-.68-2.6 0-1.44.66-2.56a4.96 4.96 0 0 1 1.84-1.8q1.16-.68 2.58-.68 1.4 0 2.46.64 1.08.62 1.68 1.72.62 1.08.62 2.46 0 .26-.04.54a4 4 0 0 1-.1.6l-8.12.02v-1.96l6.9-.02-1.06.82q-.04-.86-.32-1.44a1.87 1.87 0 0 0-.78-.88q-.5-.32-1.24-.32-.78 0-1.36.36a2.3 2.3 0 0 0-.9.98q-.3.62-.3 1.48 0 .88.32 1.54.339.64.96 1 .62.34 1.44.34.74 0 1.34-.24a2.9 2.9 0 0 0 1.04-.76l1.54 1.54q-.7.82-1.72 1.24-1 .42-2.18.42m7.385-.2v-13.68h2.62V311zm-2.26-7.36v-2.3h7.14v2.3zm8.614 7.36v-9.66h2.62V311zm2.62-5.34-1.02-.68q.18-1.78 1.04-2.8.86-1.04 2.48-1.04.7 0 1.26.24.56.22 1.02.74l-1.64 1.88a1.4 1.4 0 0 0-.54-.36q-.3-.12-.7-.12-.84 0-1.38.54-.52.52-.52 1.6m5.7 5.34v-9.66h2.64V311zm1.32-11.22q-.64 0-1.06-.42a1.5 1.5 0 0 1-.42-1.08q0-.62.42-1.06t1.06-.44q.66 0 1.06.44.42.44.42 1.06 0 .64-.42 1.08-.4.42-1.06.42m8.201 11.42q-1.48 0-2.66-.66a4.9 4.9 0 0 1-1.86-1.8q-.68-1.14-.68-2.56 0-1.44.68-2.58a4.9 4.9 0 0 1 1.86-1.8q1.2-.68 2.66-.68 1.14 0 2.1.42t1.66 1.2l-1.68 1.7a2.5 2.5 0 0 0-.92-.64 2.9 2.9 0 0 0-1.16-.22q-.72 0-1.3.34a2.43 2.43 0 0 0-.9.9q-.32.56-.32 1.34 0 .76.32 1.36.34.58.9.92.58.32 1.3.32.66 0 1.18-.22.54-.24.92-.68l1.7 1.7q-.74.8-1.7 1.22t-2.1.42m8.604.02a6 6 0 0 1-1.62-.22 6.3 6.3 0 0 1-1.44-.6 4.7 4.7 0 0 1-1.14-.96l1.56-1.58q.5.56 1.16.84t1.46.28q.64 0 .96-.18.34-.18.34-.54 0-.4-.36-.62-.34-.22-.9-.36l-1.18-.34q-.6-.2-1.16-.5-.56-.32-.92-.86-.34-.56-.34-1.44 0-.92.44-1.6.46-.68 1.3-1.06t1.98-.38q1.2 0 2.16.42.98.42 1.62 1.26l-1.58 1.58a2.6 2.6 0 0 0-1-.78q-.54-.24-1.18-.24-.58 0-.9.18-.3.18-.3.5 0 .36.34.56.36.2.92.36.56.14 1.16.34.62.18 1.16.52.56.34.9.9.36.56.36 1.44 0 1.42-1.02 2.26-1.02.82-2.78.82"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dashboard_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#206251",
    d: "M239.027 433.044c1.25.642 1.875.962 2.512.956a2.7 2.7 0 0 0 1.542-.525c.503-.383.778-.977 1.328-2.164a60.35 60.35 0 0 0 5.416-29.944c-.891-11.609-5.13-22.739-12.235-32.116-7.106-9.377-16.789-16.621-27.942-20.903a65.64 65.64 0 0 0-31.041-3.914c-1.339.157-2.01.234-2.537.597a2.6 2.6 0 0 0-.978 1.31c-.194.605-.061 1.299.203 2.689l1.669 8.752c.266 1.382.396 2.072.738 2.532.315.431.685.705 1.192.885.541.197 1.313.125 2.855-.02a47.64 47.64 0 0 1 21.462 2.954c8.097 3.109 15.128 8.37 20.286 15.175 5.159 6.808 8.237 14.889 8.882 23.315a43.8 43.8 0 0 1-3.44 20.641c-.619 1.439-.929 2.158-.9 2.732.024.539.183.968.51 1.399.35.459.992.79 2.279 1.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CDDCD8",
    d: "M186.501 347.983c0-1.409 0-2.115-.302-2.672a2.65 2.65 0 0 0-1.191-1.112c-.579-.26-1.246-.22-2.579-.134-13.234.829-25.91 5.69-36.212 13.953-11.358 9.102-19.131 21.772-21.997 35.847s-.647 28.688 6.279 41.344c6.924 12.657 18.127 22.577 31.7 28.068a64.9 64.9 0 0 0 42.734 2.052c14.06-4.167 26.203-12.964 34.365-24.899 8.163-11.932 11.835-26.259 10.396-40.543-1.306-12.967-6.759-25.17-15.527-34.902-.878-.974-1.315-1.46-1.905-1.677a2.66 2.66 0 0 0-1.62-.052c-.602.18-1.1.666-2.098 1.641l-6.492 6.342c-1.033 1.008-1.548 1.511-1.744 2.054a2.4 2.4 0 0 0-.069 1.492c.147.558.656 1.155 1.677 2.352 5.891 6.908 9.554 15.408 10.464 24.416 1.044 10.369-1.623 20.772-7.548 29.434-5.926 8.666-14.743 15.053-24.95 18.077a47.12 47.12 0 0 1-31.024-1.489c-9.853-3.987-17.988-11.189-23.015-20.377-5.027-9.189-6.639-19.798-4.558-30.015 2.08-10.22 7.723-19.417 15.968-26.027 7.191-5.765 15.974-9.252 25.179-10.046 1.546-.134 2.317-.203 2.815-.492a2.4 2.4 0 0 0 1.004-1.091c.25-.515.25-1.224.25-2.641z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 13,
    x: 315,
    y: 346,
    fill: "#E9EFEC",
    rx: 6.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 13,
    x: 279,
    y: 346,
    fill: "#E9EFEC",
    rx: 6.5
  })), /*#__PURE__*/React.createElement("rect", {
    width: 323,
    height: 135,
    x: 92.5,
    y: 331.5,
    stroke: "#E6EDEA",
    rx: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 206,
    height: 135,
    x: 438.5,
    y: 341.5,
    stroke: "#E6EDEA",
    rx: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 13,
    x: 458,
    y: 356,
    fill: "#E9EFEC",
    rx: 6.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 151,
    height: 13,
    x: 458,
    y: 377,
    fill: "#E9EFEC",
    rx: 6.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dashboard_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h738v430H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dashboard_svg__b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 722,
    height: 414,
    x: 8,
    y: 8,
    fill: "#fff",
    rx: 32
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dashboard_svg__c"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 553,
    height: 179.751,
    x: 92,
    y: 78.125,
    fill: "#fff",
    rx: 11.631
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dashboard_svg__d"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 324,
    height: 136,
    x: 92,
    y: 331,
    fill: "#fff",
    rx: 6
  })))));
};
export default SvgDashboard;